export const translations = {
  zh: {
    nav: {
      home: "首页",
      platform: "合作平台",
      ea: "EA 策略",
      indicators: "指标库",
      tutorials: "教学",
      about: "关于我们",
      openAccount: "咨询合作",
    },
    hero: {
      tagline: "QUANT · AUTOMATION · SYSTEM",
      title1: "无限量化",
      title2: "重塑交易",
      title3: "自动交易",
      subtitle:
        "顶级 EA 策略 · MT4/MT5 · CG 合作平台 · 黄金 XAUUSD / COMEX 量化解决方案",
      cta1: "咨询合作",
      cta2: "了解 EA 策略",
      stats: [
        { v: "120+", l: "合作交易员" },
        { v: "15", l: "量化策略" },
        { v: "24/7", l: "托管运行" },
        { v: "99.9%", l: "VPS 在线率" },
      ],
    },
    broker: {
      label: "PARTNER BROKER",
      title: "合作平台",
      desc: "我们与 CG 平台深度合作，为交易者与 EA 经营者提供专业级交易环境、低延迟执行、稳定点差与多层风控。",
      activities: "活动与规则",
      faq: "常见问题",
      activitiesList: [
        { t: "策略共享&技术支持", d: "" },
        { t: "资金方合作", d: "机构与高净值资金方开通独立风控通道。" },
      ],
      faqs: [
        { q: "合作需要多少资金？", a: "起步资金建议 $100；专业级策略与风控建议 $1,000 起。" },
        { q: "出入金周期？", a: "工作日入金实时到账，出金一般 1-3 个工作日。" },
        { q: "支持哪些交易品种？", a: "货币对、贵金属、指数、原油、数字货币。" },
        { q: "是否支持自己的 EA？", a: "支持，CG 提供低延迟 MT4/MT5 与 VPS 一键部署。" },
      ],
      scan: "咨询合作",
      visitSite: "进入 CG 官网",
    },
    ea: {
      label: "AUTOMATED STRATEGIES",
      title: "EA 策略矩阵",
      subtitle: "每一套 EA 都经过至少 12 个月实盘、夏普比、最大回撤与尾部风险压力测试。",
      col: {
        symbol: "品种",
        platform: "平台",
        profit: "月化收益",
        dd: "最大回撤",
        risk: "风险等级",
        min: "建议资金",
        coop: "合作条件",
      },
      cta: "查看详情",
      viewAll: "查看全部 EA",
      searchPlaceholder: "搜索 EA 名称或品种...",
      filterPlatform: "平台",
      filterRisk: "风险",
      detailBack: "← 返回列表",
      detailEquity: "实盘净值曲线",
      detailFeatures: "核心优势",
      detailSetup: "部署说明",
      detailCoop: "合作条件",
      detailStrategy: "策略说明",
      detailApply: "申请合作",
      detailLoading: "加载净值曲线中...",
    },
    indicators: {
      label: "TECHNICAL OVERLAYS",
      title: "指标库",
      subtitle: "为 MT4/MT5 精心打造的多维度技术指标，免费提供给合作伙伴。",
      cta: "查看详情",
      viewAll: "查看全部指标",
      searchPlaceholder: "搜索指标名称...",
      detailBack: "← 返回列表",
      detailFeatures: "核心功能",
      detailUsage: "使用说明",
      detailCategory: "类别",
      detailApply: "申请使用",
    },
    tutorials: {
      label: "LEARNING CENTER",
      title: "教学资源",
      subtitle: "从 0 到 1 建立量化交易体系，配套百度云盘课程资料。",
      download: "前往下载",
      viewAll: "查看全部教学",
      searchPlaceholder: "搜索教程标题...",
    },
    about: {
      label: "ABOUT & JOIN",
      title: "关于我们 · 加入无限",
      subtitle:
        "我们是一支由量化工程师、前投行交易员与展览展示级 UI 工程师组成的团队。",
      benefitsTitle: "加入我们的好处",
      benefits: [
        { t: "策略共享", d: "全部 EA、指标、风控模型开放给核心成员。" },
        { t: "流量扶持", d: "百度 SEO / 投放 / AI 检索一站式流量资源。" },
        { t: "资金对接", d: "对接机构资金方与跟单资金池。" },
        { t: "技术底座", d: "自研 VPS 集群 + 低延迟直连。" },
      ],
      teamTitle: "核心团队",
      formTitle: "加入我们",
      contactTitle: "留下联系方式",
      name: "姓名",
      contact: "微信 / 电话",
      email: "邮箱（可选）",
      message: "你的方向或留言",
      submit: "提交",
      submitting: "提交中...",
    },
    footer: {
      rights: "版权所有",
      disclaimer:
        "保证金交易涉及重大风险，可能导致资金损失。本站内容仅供参考，不构成投资建议。",
    },
    toast: {
      success: "提交成功！我们会尽快联系你。",
      error: "提交失败，请稍后再试。",
    },
  },
  en: {
    nav: {
      home: "Home",
      platform: "Broker",
      ea: "EA",
      indicators: "Indicators",
      tutorials: "Tutorials",
      about: "About",
      openAccount: "Contact",
    },
    hero: {
      tagline: "QUANT · AUTOMATION · SYSTEM",
      title1: "MetaTrader",
      title2: "Reengineered",
      title3: "Auto Trading",
      subtitle:
        "Top-tier EA strategies · MT4/MT5 · Partner broker support · Gold XAUUSD / COMEX quant solutions",
      cta1: "Contact",
      cta2: "Explore EAs",
      stats: [
        { v: "120+", l: "Partner Traders" },
        { v: "15", l: "Strategies" },
        { v: "24/7", l: "Hosted" },
        { v: "99.9%", l: "VPS Uptime" },
      ],
    },
    broker: {
      label: "PARTNER BROKER",
      title: "Broker",
      desc: "We partner with CG to deliver professional trading infrastructure: low-latency execution, stable spreads and layered risk management.",
      activities: "Activities & Rules",
      faq: "FAQ",
      activitiesList: [
        { t: "Strategy sharing & technical support", d: "" },
        { t: "Capital Partnership", d: "Dedicated risk lane for institutions and high-net-worth capital." },
      ],
      faqs: [
        { q: "Minimum capital?", a: "Standard $100; Pro EA accounts recommended from $1,000." },
        { q: "Deposit / Withdrawal?", a: "Instant deposits, withdrawals in 1-3 business days." },
        { q: "Supported symbols?", a: "Currency pairs, metals, indices, oil, and crypto." },
        { q: "Can I run my own EA?", a: "Yes, MT4/MT5 with one-click VPS deploy." },
      ],
      scan: "Contact",
      visitSite: "Visit CG Website",
    },
    ea: {
      label: "AUTOMATED STRATEGIES",
      title: "EA Strategy Matrix",
      subtitle: "Every EA is stress-tested for 12+ months of live trading, Sharpe, max drawdown and tail risk.",
      col: {
        symbol: "Symbol",
        platform: "Platform",
        profit: "Monthly",
        dd: "Max DD",
        risk: "Risk",
        min: "Min Capital",
        coop: "Partnership",
      },
      cta: "View Detail",
      viewAll: "View all EAs",
      searchPlaceholder: "Search EA or symbol...",
      filterPlatform: "Platform",
      filterRisk: "Risk",
      detailBack: "← Back",
      detailEquity: "Live equity curve",
      detailFeatures: "Key Features",
      detailSetup: "Deployment",
      detailCoop: "Partnership",
      detailStrategy: "Strategy",
      detailApply: "Apply",
      detailLoading: "Loading equity curve...",
    },
    indicators: {
      label: "TECHNICAL OVERLAYS",
      title: "Indicator Library",
      subtitle: "Multi-dimensional MT4/MT5 indicators, free for partners.",
      cta: "View Detail",
      viewAll: "View all indicators",
      searchPlaceholder: "Search indicator...",
      detailBack: "← Back",
      detailFeatures: "Features",
      detailUsage: "Usage",
      detailCategory: "Category",
      detailApply: "Apply",
    },
    tutorials: {
      label: "LEARNING CENTER",
      title: "Tutorials",
      subtitle: "Build your quant stack from zero, with Baidu Pan course packages.",
      download: "Download",
      viewAll: "View all tutorials",
      searchPlaceholder: "Search tutorial...",
    },
    about: {
      label: "ABOUT & JOIN",
      title: "About · Join Us",
      subtitle:
        "A team of quant engineers, ex-IB traders and exhibition-grade UI engineers.",
      benefitsTitle: "Why Join",
      benefits: [
        { t: "Strategy Access", d: "Full EAs, indicators and risk models for core members." },
        { t: "Traffic Support", d: "Baidu SEO, ads and AI-search distribution." },
        { t: "Capital Access", d: "Institutional capital and copy-trading pools." },
        { t: "Tech Backbone", d: "In-house VPS cluster + low-latency routes." },
      ],
      teamTitle: "Core Team",
      formTitle: "Join Us",
      contactTitle: "Leave Your Contact",
      name: "Name",
      contact: "WeChat / Phone",
      email: "Email (optional)",
      message: "Your focus or message",
      submit: "Submit",
      submitting: "Submitting...",
    },
    footer: {
      rights: "All rights reserved",
      disclaimer:
        "Leveraged trading carries substantial risk. Content is informational only, not investment advice.",
    },
    toast: {
      success: "Submitted! We'll reach out shortly.",
      error: "Submission failed, please try again.",
    },
  },
};
